"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHORIZATION_HEADER = void 0;
/**
 * Authorization header name required by Apple ASA API.
 */
exports.AUTHORIZATION_HEADER = "Authorization";
